import React, { useState } from "react";
import { Blocks } from "lucide-react";

/* An app's mark. The catalog is Composio's, so the logo is a URL on their CDN
   rather than one of our own icon maps — and `logo` is nullable on the wire,
   which is what the glyph is for. A URL that fails to load falls back to the
   app's initial on the same tile, never the browser's broken-image icon. (The
   built-in apps' logos are bundled — shared/lib/app-logos — so they can't fail.)

   In `shared/` because three features draw an app: this page, the agent
   Configure panel and the sidebar's app stack (rule book §1 rule 5). */
export function AppLogo({ logo, name, size = 36, iconSize = 20, rounded = 10, className = "" }: {
  logo?: string | null;
  name: string;
  size?: number;
  iconSize?: number;
  rounded?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  return (
    <div
      className={`shrink-0 bg-[var(--surface-sunk)] ring-1 ring-[var(--hairline)] flex items-center justify-center ${className}`}
      style={{ width: size, height: size, borderRadius: rounded }}
    >
      {logo && !failed ? (
        <img src={logo} alt={name} onError={() => setFailed(true)} style={{ width: iconSize, height: iconSize }} />
      ) : logo ? (
        <span aria-label={name} className="font-medium text-[var(--text-secondary)] uppercase" style={{ fontSize: Math.round(iconSize * 0.8) }}>
          {name.charAt(0)}
        </span>
      ) : (
        <Blocks
          className="text-[var(--text-tertiary)]"
          strokeWidth={1.75}
          style={{ width: iconSize, height: iconSize }}
        />
      )}
    </div>
  );
}
